export const BG = '#F2F2F7';
export const FONT_BODY = "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif";
export const FONT_MONO = FONT_BODY;

export const C = {
  blue:   "#007AFF", blueL:  "#E5F1FF", blueB:  "#A8CBFF",
  green:  "#34C759", greenL: "#E5F9EC", greenB: "#A2EBBF",
  red:    "#FF3B30", redL:   "#FFECEB", redB:   "#FFB3AF",
  amber:  "#FF9500", amberL: "#FFF3E0", amberB: "#FFD080",
  purple: "#AF52DE", purpleL:"#F5E9FF", purpleB:"#D9ADEF",
  cyan:   "#32ADE6", cyanL:  "#E5F5FF", cyanB:  "#A8DAFA",
  text:   "#000000", muted:  "#3C3C43", subtle: "#8E8E93",
  border: "#C6C6C8", bg:     BG,        card:   "#FFFFFF",
  fill:   "#E5E5EA",
};
export const SCHEDA_PALETTE = ["#007AFF","#34C759","#AF52DE","#FF9500","#32ADE6","#FF3B30","#FF2D55","#30B0C7"];

// Shared card visual style — no padding/margin so flex items can override freely
export const CARD_STYLE = {
  background: '#ffffff',
  borderRadius: 20,
  boxShadow: 'none',
  border: 'none',
};

export const CARD_SHADOW = "0 1px 4px rgba(0,0,0,0.04)";

export const St = {
  page:    { fontFamily:FONT_BODY, background:BG, minHeight:"100vh", color:C.text, paddingBottom:120, WebkitFontSmoothing:"antialiased", MozOsxFontSmoothing:"grayscale", fontFeatureSettings:'"kern" 1, "liga" 1, "calt" 1', textRendering:"optimizeLegibility" },
  wrap:    { maxWidth:560, margin:"0 auto", padding:"0 0 0", minHeight:"100vh" },
  card:    { ...CARD_STYLE, padding:"18px 20px", marginBottom:10 },
  label:   { display:"block", fontSize:13, fontWeight:500, color:C.subtle, letterSpacing:-0.1, marginBottom:6 },
  input:   { width:"100%", padding:"12px 16px", border:"1px solid #EAEAEA", borderRadius:8, fontFamily:FONT_BODY, fontSize:16, color:C.text, background:"#fff", outline:"none", boxSizing:"border-box", boxShadow:"none" },
  mono:    { fontFamily:FONT_MONO, fontWeight:500 },
  monoIn:  { fontFamily:FONT_MONO, fontWeight:500, fontSize:16, textAlign:"center" },
  divider: { height:"1px", background:"rgba(60,60,67,0.12)", margin:"0" },
  secTit:  { fontSize:13, fontWeight:600, color:C.subtle, letterSpacing:0.4, textTransform:"uppercase", marginBottom:12 },
  chip:    (col=C.blue,bg)=>({ display:"inline-flex", alignItems:"center", gap:5, padding:"4px 12px", background:bg||`${col}15`, borderRadius:20, fontSize:12, color:col, fontWeight:600, marginBottom:14 }),
  pill:    (a,col=C.blue)=>({ padding:"6px 16px", border:"none", borderRadius:20, background:a?col:C.fill, color:a?"#fff":C.muted, fontFamily:FONT_BODY, fontWeight:600, fontSize:13, cursor:"pointer", transition:"all 0.15s" }),
  btn:     (col=C.blue,outline=false)=>({ padding:"13px 20px", border:"none", borderRadius:8, background:outline?`${col}10`:col, color:outline?col:"#fff", fontFamily:FONT_BODY, fontWeight:600, fontSize:16, cursor:"pointer", transition:"opacity 0.15s" }),
  tag:     (col,bg)=>({ display:"inline-flex", alignItems:"center", gap:4, padding:"3px 10px", background:bg||`${col}15`, borderRadius:20, fontSize:12, color:col, fontWeight:600 }),
  display: { fontFamily:FONT_BODY, fontWeight:800, fontSize:52, color:C.text, letterSpacing:-2, lineHeight:1 },
};

export const focus = e=>{ e.target.style.boxShadow=`0 0 0 3px ${C.blue}30, ${CARD_SHADOW}`; };
export const blur  = e=>{ e.target.style.boxShadow=CARD_SHADOW; };

// Global CSS injected once at app root — press-state feedback + spring animation primitives
export const GP_GLOBAL_CSS = `
  html, body { background: ${BG}; }
  .gp-btn-press:active { transform: scale(0.97); }
  .gp-tap:active { opacity: 0.72; }
  @keyframes gpFadeUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
  @keyframes gpFadeIn { from { opacity:0; } to { opacity:1; } }
  @keyframes gpCardIn { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
  @keyframes gpSpinSm { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
  * { -webkit-tap-highlight-color: transparent; }
`;

export const SPRING = 'cubic-bezier(0.22,1,0.36,1)';
export const SPRING_FAST = 'cubic-bezier(0.34,1.56,0.64,1)';
